import { useState } from "react";
import { Link } from "react-router-dom";
import { Check, X } from "lucide-react";
import api from "../lib/api";

const STEPS = {
  store: { title: "Opret butik", doneText: "Butikken er oprettet" },
  facebook: { title: "Forbind jeres Facebook-side", doneText: "Facebook-siden er forbundet", todo: "Så kan robotten svare på \"ja tak\" og lægge jeres tilbud op.", cta: "Forbind Facebook-side", to: "/settings#facebook" },
  offer: { title: "Læg første tilbud op", doneText: "Første tilbud er lagt op", todo: "Opret et ja tak-tilbud og læg det op på jeres side.", cta: "Opret første tilbud", to: "/offers/new" },
};

function detail(s, bannerShown) {
  const m = STEPS[s.key];
  if (s.done) return m.doneText;
  if (s.key === "facebook" && s.broken) return bannerShown ? "Forbindelsen er afbrudt – se advarslen ovenfor" : "Forbindelsen er afbrudt";
  if (s.key === "offer" && s.test_only) return "I har lavet et testtilbud – læg et rigtigt op, når siden er forbundet";
  return m.todo;
}

export default function Onboarding({ data, bannerShown }) {
  const [gone, setGone] = useState(false);
  if (!data?.visible || gone) return null;
  const dismiss = () => { setGone(true); api.post("/onboarding/dismiss").catch(() => {}); };
  const n = data.steps.filter((s) => s.done).length;
  const next = data.steps.find((s) => !s.done);

  if (data.all_done) {
    return (
      <section className="ob done" data-testid="onboarding-card">
        <div className="ob-party" data-testid="onboarding-complete">
          <span className="ob-dot on"><Check size={16} /></span>
          <div>
            <b>Alt er klar 🎉</b>
            <p>Robotten svarer nu på jeres ja tak-kommentarer.</p>
          </div>
          <button type="button" className="btn small" onClick={dismiss} data-testid="onboarding-close">Luk</button>
        </div>
      </section>
    );
  }

  return (
    <section className="ob" data-testid="onboarding-card">
      <div className="ob-head">
        <div>
          <h2>Kom i gang med JaTak Pro</h2>
          <span className="ob-count" data-testid="onboarding-progress">{n} af 3 trin</span>
        </div>
        <button type="button" className="ob-hide" onClick={dismiss} aria-label="Skjul kom i gang" data-testid="onboarding-hide">
          Skjul <X size={14} />
        </button>
      </div>
      <div className="ob-bar" aria-hidden="true"><i style={{ width: `${(n / 3) * 100}%` }} /></div>
      <ol className="ob-steps">
        {data.steps.map((s, i) => {
          const isNext = s === next;
          const broken = s.key === "facebook" && s.broken;
          return (
            <li key={s.key} className={s.done ? "is-done" : isNext ? "is-next" : "is-later"} data-testid={`onboarding-step-${s.key}`} data-done={s.done}>
              <span className={`ob-dot${s.done ? " on" : ""}`}>{s.done ? <Check size={15} /> : i + 1}</span>
              <div className="ob-text">
                <b>{STEPS[s.key].title}</b>
                <span className={broken ? "ob-warn" : ""} data-testid={`onboarding-step-${s.key}-detail`}>{detail(s, bannerShown)}</span>
              </div>
              {isNext && STEPS[s.key].cta && !(broken && bannerShown) && (
                <Link className="btn primary small" to={STEPS[s.key].to} data-testid={`onboarding-cta-${s.key}`}>{STEPS[s.key].cta}</Link>
              )}
            </li>
          );
        })}
      </ol>
    </section>
  );
}
